var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('nevron-file-field',{attrs:{"allowedFileTypes":_vm.fileExtensions,"title":"image-or-video","file":_vm.media},on:{"selected":_vm.mediaChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }